<template>
    <div class="mt-3">
        <div style="text-align: right;" class="mr-3">
            <slot />
        </div>
        <div class="app-bar mb-8">
            <v-row>
                <v-col class="mr-5 d-flex router-link-section">
                    <router-link v-for="route in routes" 
                        :key="route.to" 
                        :to="route.path"
                        class="router-link-base"
                        :class="{'ml-6': route.meta.showInNavigation}"
                    >
                        <div v-if="route.meta.showInNavigation"
                             class="display-key" 
                        >
                            {{ route.name }}
                        </div>
                    </router-link>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import routes from '@/router/routes'

export default {
    name: 'NavigationDesktop',
    data: function() {
        return {
            routes: routes
        }
    },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/global.scss';

.app-bar {
    height: $app-bar-height-desktop;
}

.router-link-section {
    justify-content: flex-end;
    align-items: center;
}

</style>